export default __webpack_public_path__ + "static/media/wallet.1114487f.svg";